import en from '../../../../lang/en-us';
const { dashboard } = en;
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import { SubmitButton } from '../../../../lib/Button';
import { ActionHeader, FaqLink } from '..';
import { BANK } from '../../../../redux-store/types/nct';
import { MINOR_MAJOR } from '../../../../utils/constants';

export function MinorStatusList(props: any) {
    const { targetFunds: Funds = [], newPan, nomineeData } = props.location.state || {};
    const { bank: bankList = [] } = Funds[0] || {};
    const defaultBank = bankList.find((bank: BANK) => bank.default === 'Y');

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
    }, []);

    const handleSubmit = () => {
        props.history.replace('minor-status-review', { Funds, newPan, nomineeData });
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.MinorStatus.MinorStatusHeading} />
            <div className="curved-bg-content update-pan-selected-content">
                <div className="curved-bg-content-inner minor-review">
                    <div className="curved-bg-content-inner-top">
                        <p>{dashboard.MinorStatus.ReviewDetails.subheading}</p>
                        {!!Funds.length && (
                            <div className="selected-folios-list">
                                <h3>{defaultBank?.name || 'Bank Name'}</h3>
                                <a
                                    className="edit-folio"
                                    onClick={() =>
                                        props.history.push('minor-status-edit-bank', {
                                            Funds,
                                            defaultBank,
                                            newPan,
                                        })
                                    }
                                >
                                    <img src="/images/edit-fill-purple.svg" alt="delete icon" />
                                </a>
                                <div className="curved-table-filters-selected">
                                    <div className="curved-table-filters-selected-tags">
                                        <p>Folios: </p>
                                        <div className="tags">
                                            {Funds.map((_ele: ConsolidateTableRowType) => (
                                                <span>{_ele.folio}</span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="selected-folios-list-bottom">
                                    <p>
                                        {dashboard.MinorStatus.ReviewDetails.accountNo}
                                        <span>{defaultBank?.accountNo || 'NA'}</span>
                                    </p>
                                    <p>
                                        {dashboard.MinorStatus.ReviewDetails.ifsc}
                                        <span>
                                            {defaultBank?.ifsc || defaultBank?.neftIfsc || 'NA'}
                                        </span>
                                    </p>
                                    <p>
                                        {dashboard.MinorStatus.ReviewDetails.accountType}
                                        <span>{defaultBank?.accountType || 'NA'}</span>
                                    </p>
                                </div>
                            </div>
                        )}
                        <FaqLink section={MINOR_MAJOR} history={props.history} />
                        <div className="curved-bg-content-inner-bottom">
                            <SubmitButton
                                onClick={handleSubmit}
                                className="customBtn"
                                label={dashboard.MinorStatus.ReviewDetails.buttonText}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default connect(null)(MinorStatusList);
